module.exports = __webpack_public_path__ + "img/beginners-cat.10fb55bf.webp";